import { DEFAULT_GRADIENT_CSS } from './defaults.js';
/**
 * Build a CSS `linear-gradient(...)` string from adventure-style gradient fields.
 * Falls back to Storynity default gradient when fewer than two colors are provided.
 */
export function buildGradient(style) {
    const angle = style.gradient_angle ?? 135;
    const colors = style.background_gradient;
    if (!colors || colors.length < 2) {
        console.warn('Invalid gradient: requires at least 2 colors, falling back to default');
        return DEFAULT_GRADIENT_CSS;
    }
    const colorStops = colors
        .map((color, idx) => {
        const position = (idx / (colors.length - 1)) * 100;
        return `${color} ${position}%`;
    })
        .join(', ');
    return `linear-gradient(${angle}deg, ${colorStops})`;
}
//# sourceMappingURL=gradient.js.map